import { watch } from 'vue'
import { appendScript } from 'utilities/appendScript'
import { FORTER_SCRIPT, FORTER_SCRIPT_PROD } from 'constants/forterScript'
import store from 'store'
// Eager, side-effect-only import: registers the ftr:tokenReady listener at the same early
// point this script is injected, rather than waiting for the payment page to mount it late.
import 'src/composables/useForterToken'

export function useForterScript() {
  // `setting/getInit` (and therefore isForterEnabled) is only populated once the init API
  // resolves — an async chain that runs well after this composable's call site (App.vue /
  // OtaApp.vue's root setup()) has already executed synchronously. A one-time check here would
  // always read the still-empty default state and permanently skip injecting the script, so
  // this has to watch for the flag turning true instead of checking it once.
  const stopWatch = watch(
    () => store.getters['setting/isForterEnabled'],
    (isForterEnabled) => {
      if (!isForterEnabled) return
      stopWatch()

      const script =
        TARGET_ENV === 'production'
          ? `<script id="6e4cb6a0bd65" type="text/javascript">${FORTER_SCRIPT_PROD}<` + '/script>'
          : `<script id="dc2ee488b13d" type="text/javascript">${FORTER_SCRIPT}<` + '/script>'

      appendScript('head', script)
    },
    { immediate: true }
  )
}
